import { Component, OnInit, forwardRef, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, FormBuilder, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatInput, MatOptionSelectionChange, MatAutocompleteSelectedEvent } from '@angular/material';
import { Guid } from '../../core/guid';

@Component({
  selector: 'pnx-autocomplete',
  templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AutocompleteComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => AutocompleteComponent), multi: true }
    ]
})
export class AutocompleteComponent implements OnInit {

    @ViewChild('input', { read: MatInput }) input: MatInput;
    @Input() label: string;
    @Input() placeholder: string;
    @Input() flex: string;
    codeValue: string = '';
    @Input('value') _value = '';
    @Input() itemcollection: any;
    @Input() items: Coded[] = [];
    @Input() mandatory: boolean = false;
    @Input() disable: boolean = false;
    @Input() codedcontainerstyle: string = 'row';
    @Input() codedctrlstyle: string = '';
    @Input() labelstyle: string = 'control-label';
    @Input() selectedValue: string;

    myControl = new FormControl();
    filteredCoded: Observable<Coded[]>;
    filteredStates: Observable<Coded[]>;
    @Output() callbackEvent: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();
    @Output() selectChangeValue: EventEmitter<any> = new EventEmitter<any>();
    name: string;

    cmdGetData(event: KeyboardEvent) {
        if (event.keyCode != 38 && event.keyCode != 40) {
            this.callbackEvent.emit(event);
            this.items = this.itemcollection;
        }
    }

    constructor() {
        this.filteredStates = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(state => state ? this._filterStates(state) : this.items.slice())
        );
        this.itemSelected(null);
    }

    private _filterStates(value: string): Coded[] {
        const filterValue = value.toLowerCase();

        return this.items.filter(state => state.Description.toLowerCase().indexOf(filterValue) === 0);
    }

    ngOnInit() {
    }

    getErrorMessage() {
        return this.myControl.hasError('required') ? 'Required parameter is missing' : '';
    }

    //displayFn(item): string {
    //  return item;
    //}


    ngOnChanges() {
        this.items = this.itemcollection;
    }

    itemSelected(event: MatAutocompleteSelectedEvent) {
        debugger
       
        for (let k in this.items) {
            if (event.option.value === this.items[k].Description) {
                this._value = this.items[k].CodeValue;
                this.name = this.items[k].Description;
            }
            if (this.selectedValue != this.items[k].Description) {
                this._value = this.items[k].CodeValue;
                this.name = this.items[k].Description;
            }
        }
        this.propagateChange(this._value);
        this.selectChangeValue.emit(this.name)
    }

    changeEvent(event: MatOptionSelectionChange) {
        for (let k in this.items) {
            if (event.source.value === this.items[k].Description) {
                this._value = this.items[k].CodeValue;
            }
        }
        this.propagateChange(this._value);
    }

    selectChange(selectValue: string) {
        if (selectValue.trim() == '') {
            this._value = '';
        }
        this.propagateChange(this._value);
    }

    propagateChange: any = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        if (val == "" || val == null || val == Guid.emptyGuid() || val == '0') {
            this.myControl.setValue('');
        }
        else {
            this._value = String(val);
            for (let k in this.items) {
                if (this._value.toLowerCase() === this.items[k].CodeValue.toLowerCase()) {
                    this._value = this.items[k].CodeValue;
                    val = this.items[k].Description;
                }
            }
            if (this._value != val)
                this.myControl.setValue(val);
            else
                this.myControl.setValue('');
        }
    }

    writeValue(value): void {
        if (value != null) {
            this.value = value;
        }
        if (this.disable) {
            this.myControl.disable();
        }
    }



    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() { }
    public validate(parentControl: AbstractControl): { [key: string]: any } {

        const val = parentControl.value;

        if (this.mandatory) {

            this.myControl.setValidators(Validators.required);
            parentControl.setValidators(Validators.required);

            if (!parentControl.value) {
                parentControl.setValue(null);
            }

            if (!val) {
                return { valid: false };
            }
        }
        else {

            this.myControl.clearValidators();
            parentControl.clearValidators();

            if (!parentControl.value) {
                parentControl.setValue(null);
            }
        }

        if (!parentControl.disabled && this.disable) {
            parentControl.disable();
        }

        return null;
    }
}

export interface Coded {
    CodeValue: string;
    Description: string;
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/autocomplete.component.ts